import { FC } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import RouteConstants from '@/features/router/RouteConstants';
import { CampaignsInnerRoutePlaceholderV2 } from '@/features/campaigns/v2/components/CampaignsInnerRoutePlaceholderV2';
import { CampaignsCreditPackagesSection } from '@/features/campaigns/v2/components/CampaignsCreditPackagesSection';
import { CampaignsEmailCreateFlowV2 } from './CampaignsEmailCreateFlowV2';
import { CampaignsEmailEditFlowV2 } from './CampaignsEmailEditFlowV2';
import { EmailCampaignList } from '../campaigns/EmailCampaignList';
import { EmailCampaignDetails } from '../campaigns/EmailCampaignDetails/EmailCampaignDetails';
import { EmailTemplateList } from '../templates/EmailTemplateList';
import { EmailTemplateCreation } from '../templates/Workaround/EmailTemplateCreation';
import { EmailTemplateEditWorkaround } from '../templates/Workaround/EmailTemplateEditWorkaround';
import { EmailTemplateDeleteWorkaround } from '../templates/Workaround/EmailTemplateDeleteWorkaround';
import { EmailSendingDomainsView } from '../domains/EmailSendingDomainsView';

const EmailTemplateDetailView: FC = () => {
  const { templateId } = useParams<{ templateId: string }>();
  return <CampaignsInnerRoutePlaceholderV2 title='Email template details' description={`Details view for template ${templateId}.`} />;
};

const EmailPackagesView: FC = () => <CampaignsCreditPackagesSection channel='email' />;

export const CampaignsEmailRoutesV2: FC = () => (
  <Switch>
    <Route exact path={RouteConstants.emailCampaigns} component={EmailCampaignList} />
    <Route exact path={RouteConstants.createCampaignEmail} component={CampaignsEmailCreateFlowV2} />
    <Route exact path={RouteConstants.editCampaignEmail} component={CampaignsEmailEditFlowV2} />
    <Route exact path={RouteConstants.emailCampaignDetails} component={EmailCampaignDetails} />

    <Route exact path={RouteConstants.emailTemplates} component={EmailTemplateList} />
    <Route exact path={RouteConstants.createEmailTemplate} component={EmailTemplateCreation} />
    <Route exact path={RouteConstants.emailTemplatesEditHub} component={EmailTemplateEditWorkaround} />
    <Route exact path={RouteConstants.emailTemplatesDeleteHub} component={EmailTemplateDeleteWorkaround} />
    <Route exact path={RouteConstants.emailTemplateDetails} component={EmailTemplateDetailView} />
    <Route exact path={RouteConstants.editEmailTemplate} component={EmailTemplateDetailView} />
    <Route exact path={RouteConstants.emailPackages} component={EmailPackagesView} />
    <Route exact path={RouteConstants.emailDomains} component={EmailSendingDomainsView} />

    <Route exact path={`${RouteConstants.campaigns}/email`}>
      <Redirect to={RouteConstants.emailCampaigns} />
    </Route>
  </Switch>
);
